import { DotLegalButton, DotLegalOverflowMenu, DotLegalPageHeader, DotLegalTableWithControls, ITableHeader } from "@dotlegal/dotlegal-ui-components";
import { Box, TableCell, TableRow } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { useTranslation } from "@localization/useTranslation";
import DotLegalDeleteDialogWrapper from "@common/components/dotLegalDeleteDialog/DotLegalDeleteDialogWrapper";
import useIncidentTypesHooks from "./IncidentTypes.hooks";
import { IncidentType } from "./IncidentTypes.types";
import AddEditIncidentTypeDialog from "../addEditIncidentTypeDialog/AddEditIncidentTypeDialog";
import TablePagePaper from "@common/components/tablePagePaper/TablePagePaper";

function IncidentTypes() {
    const {
        incidentTypes,
        isLoading,
        breadCrumbs,
        getMenuItems,
        onDialogClose,
        showCreateDialog,
        onSaved,
        incidentTypeForDeletion,
        setIncidentTypeForDeletion,
        onDelete,
        onCreateClick,
        canManageMasterData,
        incidentTypeForUpdate,
        isDeleting,
    } = useIncidentTypesHooks();
    const { translateString } = useTranslation();

    const headers = Array<ITableHeader<IncidentType>>();
    headers.push({ property: "name", text: translateString("name") });
    headers.push({ property: "isCustom", text: translateString("standardMasterData") });

    return (
        <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
            <DotLegalPageHeader
                breadCrumbs={breadCrumbs}
                rightComponent={
                    canManageMasterData ? (
                        <DotLegalButton size="medium" buttonType={"primary"} onClick={onCreateClick}>
                            {translateString("createIncidentType")}
                        </DotLegalButton>
                    ) : undefined
                }
            />
            <TablePagePaper>
                <DotLegalTableWithControls
                    internalScroll
                    headers={headers}
                    isLoading={isLoading}
                    data={incidentTypes}
                    emptyText={translateString("noData")}
                    defaultOrderBy={"name"}
                    hideRowsPerPage
                    getUserSpecificPageLength={() => 100}
                    labelRowsPerPage={translateString("showEntites")}
                    labelSearch={translateString("search")}
                    noOptionsLabel={translateString("noOptions")}
                    paginationLabelOf={translateString("labelOf")}
                    clickableRows={false}
                    hasOverflowMenu
                    renderRow={(row) => (
                        <TableRow key={row.id}>
                            <TableCell>{row.name}</TableCell>
                            <TableCell>
                                <Box sx={{ height: "20px !important" }}>{!row.isCustom ? <CheckIcon sx={{ height: "20px !important" }} /> : ""}</Box>
                            </TableCell>
                            <TableCell align={"right"}>{row.isCustom && <DotLegalOverflowMenu items={getMenuItems(row)} />}</TableCell>
                        </TableRow>
                    )}
                />
            </TablePagePaper>
            {incidentTypeForDeletion && (
                <DotLegalDeleteDialogWrapper
                    open
                    onDialogClose={() => setIncidentTypeForDeletion(undefined)}
                    onOkClick={onDelete}
                    itemForDeletion={incidentTypeForDeletion.name}
                    inProgress={isDeleting}
                />
            )}
            {(showCreateDialog || incidentTypeForUpdate !== undefined) && (
                <AddEditIncidentTypeDialog
                    onDialogClose={onDialogClose}
                    isAdd={incidentTypeForUpdate === undefined}
                    incidentTypeToUpdate={incidentTypeForUpdate}
                    onSaved={onSaved}
                />
            )}
        </Box>
    );
}

export default IncidentTypes;
